module.exports = __webpack_public_path__ + "static/media/vanessa-ogbuehi.0f5cbe3d.md";